import type { ExperienceCategory, DifficultyLevel } from "../types";

export const STORAGE_KEYS = {
  BUCKET_ITEMS: "bucketList_items",
  LANDMARKS: "bucketList_landmarks",
  THEME_MODE: "bucketList_themeMode",
  NOTIFICATIONS: "bucketList_notifications",
} as const;

export const EXPERIENCE_CATEGORIES: Array<{
  value: ExperienceCategory;
  label: string;
  icon: string;
}> = [
  { value: "adventure", label: "Adventure", icon: "🏔️" },
  { value: "personal-milestone", label: "Personal Milestone", icon: "🎯" },
  { value: "creative", label: "Creative", icon: "🎨" },
  { value: "social", label: "Social", icon: "👥" },
  { value: "learning", label: "Learning", icon: "📚" },
  { value: "career", label: "Career", icon: "💼" },
  { value: "health", label: "Health & Fitness", icon: "💪" },
  { value: "travel", label: "Travel", icon: "✈️" },
  { value: "other", label: "Other", icon: "⭐" },
];

export const DIFFICULTY_LEVELS: Array<{
  value: DifficultyLevel;
  label: string;
  color: string;
}> = [
  { value: "easy", label: "Easy", color: "#4caf50" },
  { value: "moderate", label: "Moderate", color: "#ff9800" },
  { value: "challenging", label: "Challenging", color: "#f44336" },
  { value: "extreme", label: "Extreme", color: "#9c27b0" },
];

export const PRESET_EXPERIENCES = [
  {
    title: "Go Skydiving",
    experienceCategory: "adventure" as ExperienceCategory,
    difficulty: "challenging" as DifficultyLevel,
    tags: ["extreme-sports", "adrenaline"],
  },
  {
    title: "Get Married",
    experienceCategory: "personal-milestone" as ExperienceCategory,
    tags: ["life-event", "family"],
  },
  {
    title: "Learn to Play an Instrument",
    experienceCategory: "creative" as ExperienceCategory,
    difficulty: "moderate" as DifficultyLevel,
    tags: ["music", "skill"],
  },
  {
    title: "Run a Marathon",
    experienceCategory: "health" as ExperienceCategory,
    difficulty: "challenging" as DifficultyLevel,
    tags: ["running", "endurance"],
  },
  {
    title: "Write a Book",
    experienceCategory: "creative" as ExperienceCategory,
    difficulty: "challenging" as DifficultyLevel,
    tags: ["writing", "publishing"],
  },
  {
    title: "Learn a New Language",
    experienceCategory: "learning" as ExperienceCategory,
    difficulty: "moderate" as DifficultyLevel,
    tags: ["language", "culture"],
  },
  {
    title: "Start a Business",
    experienceCategory: "career" as ExperienceCategory,
    difficulty: "extreme" as DifficultyLevel,
    tags: ["entrepreneurship", "business"],
  },
  {
    title: "Volunteer Abroad",
    experienceCategory: "social" as ExperienceCategory,
    difficulty: "moderate" as DifficultyLevel,
    tags: ["charity", "travel", "helping-others"],
  },
  {
    title: "Scuba Dive",
    experienceCategory: "adventure" as ExperienceCategory,
    difficulty: "moderate" as DifficultyLevel,
    tags: ["underwater", "marine-life"],
  },
  {
    title: "Go on a Road Trip",
    experienceCategory: "travel" as ExperienceCategory,
    difficulty: "easy" as DifficultyLevel,
    tags: ["driving", "adventure"],
  },
];

export const MAP_CONFIG = {
  defaultCenter: { lat: 20, lng: 0 },
  defaultZoom: 2,
  maxZoom: 18,
  minZoom: 2,
  tileLayerUrl: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  tileLayerAttribution:
    '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
} as const;

export const ROUTES = {
  HOME: "/",
  PLACES: "/places",
  EXPERIENCES: "/experiences",
  MAP_VIEW: "/map",
  SETTINGS: "/settings",
  ABOUT: "/about",
  FRIENDS: "/friends",
  ITEM_DETAILS: "/item/:id",
  CREATE_PLACE: "/places/create",
  CREATE_EXPERIENCE: "/experiences/create",
  EDIT_ITEM: "/item/:id/edit",
} as const;
